import React from 'react'
import { withRouter, RouteComponentProps } from 'react-router-dom'

import { routes } from 'constants/routes'

import ErrorMessage from 'components/ErrorMessage'
import Link from 'components/Link'
import useUserSignedIn from 'modules/user/useUserSignedIn'

import { ReactComponent as CommentsIcons } from 'icons/comments-64.svg'

interface ActivitiesEmptyStateProps extends RouteComponentProps {
  hasCommentsEnabled: boolean
}

const ActivitiesEmptyState: React.FC<ActivitiesEmptyStateProps> = props => {
  const { hasCommentsEnabled, location } = props
  const isSignedIn = useUserSignedIn()

  let body: React.ReactNode = null

  if (isSignedIn) {
    if (hasCommentsEnabled) {
      body = 'Document updates and comments will appear here.'
    } else {
      body = 'Document updates will appear here.'
    }
  } else {
    const signIn = (
      <Link
        to={{ pathname: routes.SIGN_IN.create({}), state: { from: location } }}>
        Sign in
      </Link>
    )

    const signUp = (
      <Link
        to={{ pathname: routes.SIGN_UP.create({}), state: { from: location } }}>
        sign up
      </Link>
    )

    if (hasCommentsEnabled) {
      body = (
        <>
          {signIn} or {signUp} to start the discussion.
        </>
      )
    } else {
      body = (
        <>
          {signIn} or {signUp} to start collaborating.
        </>
      )
    }
  }

  return (
    <ErrorMessage
      title="Nothing to see here"
      icon={<CommentsIcons />}
      iconSize="medium">
      {body}
    </ErrorMessage>
  )
}

export default withRouter(ActivitiesEmptyState)
